<template>
  <div class="flex flex-col">
    <p>{{ $t('Do you have a voucher code') }}</p>
    <FormulateInput
      type="text"
      v-model="voucherCode"
      class="text-secondary-500 my-3"
      :placeholder="$t('Enter your voucher code here')"
    />
    <button
      :class="[
        !voucherCode
          ? 'btn cursor-not-allowed text-gray-600 bg-gray-300'
          : checkingVoucher
          ? 'btn cursor-wait text-red-200 bg-primary-400 focus:outline-none focus:ring cursor-wait'
          : 'btn text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:ring'
      ]"
      @click.prevent.stop="redeemVoucher"
    >
      <span v-if="checkingVoucher">
        {{ $t('Checking Voucher') }}
      </span>
      <span v-else>{{ $t('Redeem') }}</span>
    </button>
    <div class="h-7">
      <span v-show="invalidVoucher" class="text-sm text-primary-500">
        {{ $t('Invalid Voucher') }}
      </span>
    </div>

    <transition name="celebration">
      <div
        v-if="showCelebration"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      >
        <div
          class="text-lg bg-white rounded-lg p-6 max-w-md mx-auto text-center shadow-lg"
        >
          <p class="text-xl">{{ $t('Congratulations') }}</p>
          <p class="mt-5">{{ $t('You have successfully') }}</p>
          <p>{{ $t('Redirecting now') }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.btn {
  @apply w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md transition duration-150 ease-in-out;
}
.celebration-enter-active,
.celebration-leave-active {
  transition: opacity 1s;
}
.celebration-enter,
.celebration-leave-to {
  opacity: 0;
}
</style>

<i18n>
en:
  Do you have a voucher code: Do you have a voucher code?
  Enter your voucher code here: Enter your voucher code here
  Checking Voucher: Checking voucher...
  Redeem: Redeem
  Invalid Voucher: Invalid voucher code
  Congratulations: 🎉 Congratulations! 🎉
  You have successfully: You have successfully redeemed your voucher.
  Redirecting now: We are redirecting you now back to profile page...

de:
  Do you have a voucher code: Hast Du einen Gutschein-Code?
  Enter your voucher code here: Gib Deinen Gutschein-Code hier ein
  Checking Voucher: Prüfe Gutschein...
  Redeem: Einlösen
  Invalid Voucher: Ungültiger Gutschein-Code
  Congratulations: 🎉 Glückwunsch! 🎉
  You have successfully: Du hast Deinen Gutschein erfolgreich eingelöst.
  Redirecting now: Wir leiten Dich jetzt zurück zur Profilseite...
</i18n>

<script>
import confetti from 'canvas-confetti'
import { call, sync } from 'vuex-pathify'

export default {
  data() {
    return {
      voucherCode: '',
      checkingVoucher: false,
      invalidVoucher: false,
      showCelebration: false
    }
  },

  props: ['rewardId'],

  computed: {
    isAuthenticated: sync('user/isAuthenticated'),
    buyerId: sync('user/userId'),
    validVoucher: sync('voucher/validVoucher'),
    urlAlias: sync('reward/urlAlias')
  },

  methods: {
    fire(particleRatio, opts) {
      confetti({
        origin: { y: 0.7 },
        ...opts,
        particleCount: Math.floor(250 * particleRatio)
      })
    },
    fireConfetti() {
      this.showCelebration = true
      this.fire(0.25, {
        spread: 26,
        startVelocity: 55
      })
      this.fire(0.2, {
        spread: 60
      })
      this.fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
      })
      this.fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
      })
      this.fire(0.1, {
        spread: 120,
        startVelocity: 45
      })
    },

    redeemVoucherCode: call('voucher/redeemVoucherCode'),
    async redeemVoucher() {
      this.invalidVoucher = false
      if (this.rewardId && this.voucherCode) {
        this.checkingVoucher = true
        await this.redeemVoucherCode({
          rewardId: this.rewardId,
          voucherCode: this.voucherCode,
          buyerId: this.buyerId
        })
        this.checkingVoucher = false
        this.invalidVoucher = !this.validVoucher

        if (this.validVoucher) {
          this.fireConfetti()
          await new Promise((resolve) => setTimeout(resolve, 4000))
          window.location.href = `/${this.urlAlias}`
        }
      }
    }
  }
}
</script>
